<div class="save-reservation-wrapper">

  <!-- Step 1: Confirmación -->
  <ng-container *ngIf="step === 1">
    <div class="dialog-icon">
      <fa-icon [icon]="faBookmark"></fa-icon>
    </div>
    <p class="dialog-title">¿Guardar carrito como reserva?</p>
    <p class="dialog-body">
      El carrito pasará a estado de reserva. Las entradas quedarán bloqueadas sin coste hasta que
      se procese la compra. Podrás encontrar esta reserva en el listado de reservas.
    </p>
    <div class="dialog-actions">
      <button class="btn-cancel" (click)="cancel()">Cancelar</button>
      <button class="btn-primary" (click)="confirm()">Continuar</button>
    </div>
  </ng-container>

  <!-- Step 2: Nombre -->
  <ng-container *ngIf="step === 2">
    <p class="dialog-title">Nombre de la reserva</p>

    <input
      class="reservation-input"
      type="text"
      placeholder="Ej. Grupo escolar 3ºA"
      [(ngModel)]="reservationName"
      [disabled]="saving"
      autocomplete="off"
      autofocus
    />

    <div *ngIf="error" class="dialog-error">{{ error }}</div>

    <div class="dialog-actions">
      <button class="btn-cancel" (click)="cancel()" [disabled]="saving">Cancelar</button>
      <button class="btn-primary" (click)="save()" [disabled]="!reservationName.trim() || saving">
        {{ saving ? 'Guardando...' : 'Guardar reserva' }}
      </button>
    </div>
  </ng-container>

  <!-- Step 3: Éxito -->
  <ng-container *ngIf="step === 3">
    <div class="dialog-icon dialog-icon--success">
      <fa-icon [icon]="faCircleCheck"></fa-icon>
    </div>
    <p class="dialog-title">¡Reserva creada!</p>
    <p class="dialog-body">
      La reserva <strong>{{ reservationName }}</strong> se ha creado correctamente.
      Las entradas están bloqueadas y listas para procesar cuando lo necesites.
    </p>
    <div class="dialog-actions dialog-actions--success">
      <button class="btn-cancel" (click)="close()">Cerrar</button>
      <button class="btn-primary" (click)="goToReservation()" *ngIf="savedReservationId">
        Ver reserva
      </button>
    </div>
  </ng-container>

</div>
